"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
const react_1 = __importDefault(require("react"));
const SelectFilter_1 = require("./SelectFilter");
const Filter = ({ rows, handleOnFilteredRows, configColumn, ...props }) => {
    const rowsRef = react_1.default.useRef([]);
    rowsRef.current = rows;
    return (react_1.default.createElement(SelectFilter_1.SelectFilter, { handleOnCollapsed: handleOnFilteredRows
            ? () => {
                // call the handleOnFilteredRows(rows) callback when the list of rows changes due to filter change
                handleOnFilteredRows(rowsRef.current);
            }
            : undefined, 
        // @ts-expect-error
        configColumn: configColumn, ...props }));
};
exports.Filter = Filter;
